import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MantenimientoProgramadoComponent } from './mantenimiento-programado/mantenimiento-programado.component';
import { MantenimientoErrorComponent } from './mantenimiento-error/mantenimiento-error.component';



@NgModule({
  declarations: [
    MantenimientoProgramadoComponent,
    MantenimientoErrorComponent
  ],
  imports: [
    CommonModule
  ]
})
export class PageMantenimientoModule { }
